/*
 * cust-v6-link-rewriter.js
 * --------------------------------------------------------------
 * Loaded globally from layout/theme.liquid. Installs a capture-
 * phase pointerdown + click listener on `document` that copies
 * the current URL's V6 filter params onto every clicked <a>
 * before the browser navigates. This is what makes filter state
 * persist across same-session navigation (homepage → PDP →
 * homepage, header logo click on PDP, etc.).
 *
 * Why this file exists separately from cust-v6-filter-controller.js:
 *   The full controller is loaded ONLY by sections/cust-v6-filter-bar
 *   (i.e., homepage + collection pages). PDPs never render the
 *   filter bar, so the controller's rewriter never installed on
 *   PDP — clicking the header logo from PDP dropped all filter
 *   state. This standalone runs everywhere.
 *
 * Idempotent: guarded by window.__vioriLinkRewriterInstalled, so
 * loading this file plus the full controller on the same page
 * is fine — only the first install binds listeners.
 *
 * Skip rules (match the controller exactly):
 *   - link already has its own filter params  → preserve intent
 *   - cross-origin, anchor (#frag), mailto/tel/sms/javascript/
 *     data/blob: schemes → leave alone
 *   - href that won't parse as a URL → leave alone
 */
(function () {
  if (window.__vioriLinkRewriterInstalled) return;
  window.__vioriLinkRewriterInstalled = true;

  var FILTER_PARAM_KEYS = {
    sort_by: true,
    scalp_type: true,
    concern: true,
    benefit: true,
    product_type: true,
    hair_likeness: true,
    scent: true,
    offer: true,
    offer_ts: true,
    'filter.p.m.custom.scalp_type': true,
    'filter.p.m.custom.shop_by_concern': true,
    'filter.p.m.custom.shop_by_benefit': true,
    'filter.p.product_type': true,
    'filter.p.m.custom.hair_likeness': true,
    'filter.p.m.custom.product_scent': true,
    // Not a filter, but it propagates the same way: the Find Your Viori
    // quiz stamps ?quiz_complete=1 on its Submit redirect and the flag has
    // to survive same-session nav so the _quiz_complete cart attribute
    // still gets written on whatever page the visitor adds to cart from.
    // MUST be listed here, not only in the controller's copy of this list:
    // this file installs its listener first, so it wins the rewrite and
    // the controller's rewriter then bails on urlHasOwnFilters().
    quiz_complete: true
  };

  function urlHasOwnFilters(u) {
    var has = false;
    u.searchParams.forEach(function (val, key) {
      if (FILTER_PARAM_KEYS[key]) has = true;
    });
    return has;
  }

  function rewriteLinkHref(a) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute('href');
    if (!href) return;
    var firstChar = href.charAt(0);
    if (firstChar === '#') return;
    if (/^(mailto|tel|sms|javascript|data|blob):/i.test(href)) return;
    var u;
    try { u = new URL(href, window.location.origin); }
    catch (_) { return; }
    if (u.origin !== window.location.origin) return;
    if (urlHasOwnFilters(u)) return;

    var current = new URLSearchParams(window.location.search);
    var changed = false;
    current.forEach(function (val, key) {
      if (FILTER_PARAM_KEYS[key] && !u.searchParams.has(key)) {
        u.searchParams.set(key, val);
        changed = true;
      }
    });
    if (changed) {
      var qs = u.searchParams.toString();
      a.setAttribute('href', u.pathname + (qs ? '?' + qs : '') + u.hash);
    }
  }

  function onLinkActivate(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a) return;
    rewriteLinkHref(a);
  }

  document.addEventListener('pointerdown', onLinkActivate, true);
  document.addEventListener('click', onLinkActivate, true);
})();

